import { theme } from 'styles/theme/theme';
class Customization {
  // border
  borderColor = theme.colors.AccentNaplesYellow;
  borderWidth = 4;

  //corner
  cornerSize = 10;
  cornerColor = theme.colors.SurfaceCultured10;
  cornerStrokeColor = '#000000';
  cornerStyle: 'circle' | 'rect' | undefined = 'circle';
  transparentCorners = false;

  getAllProperties() {
    return {
      borderColor: this.borderColor,
      borderScaleFactor: this.borderWidth,
      cornerSize: this.cornerSize,
      cornerColor: this.cornerColor,
      cornerStrokeColor: this.cornerStrokeColor,
      cornerStyle: this.cornerStyle,
      transparentCorners: this.transparentCorners,
    };
  }
}

const customization = new Customization();
export default customization;
